export const faqContent = [
	{
		title: 'Правила проекта',
		items: [
			{
				title: 'Правила для игроков',
				text: 'Правило 1',
			},
			{
				title: 'Оскорбления / Унижения',
				text: 'Правило 2',
			},
			{
				title: 'Оскорбления / Унижения',
				text: 'Правило 3',
			},
		],
	},
	{
		title: 'С чего начать',
		items: [
			{
				title: 'Правила для игроков',
				text: 'Правило 4',
			},
			{
				title: 'Оскорбления / Унижения',
				text: 'Правило 5',
			},
			{
				title: 'Оскорбления / Унижения',
				text: 'Правило 6',
			},
		],
	},
];
